import { API_BASE_URL } from "../../constants/index";
import HttpInterface from "../../helpers/HttpInterface";
import { UpdateCollectionDate } from "../../Models/CodCollection";
import { CodLiquidation, CreateLiquidation } from "../../Models/CodLiquidation";
import { CreateCodLiquidationPreview } from "../../Models/CodLiquidationPreview";

export class CodCollectionsService {
  private httpProxy: HttpInterface;

  constructor() {
    this.httpProxy = new HttpInterface();
  }

  /**
   * Fetches a specific cod collection by its ID from the API.
   *
   * @param id The unique identifier of the cod collection to fetch.
   * @returns A promise that resolves with the API response containing the cod collection details.
   */
  get(id: string): Promise<any> {
    const requestOptions = {
      method: "GET", // HTTP method for the request
    };

    // Constructs the URL for fetching a specific cod collection by its ID
    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/${id}`,
      requestOptions
    );
  }

  /**
   * Delete cod-collection.
   *
   * @param id
   * @returns A promise that resolves with the API response confirming the deleting of the cod-collection.
   */
  delete(id: string): Promise<any> {
    const requestOptions = {
      method: "DELETE",
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/${id}`,
      requestOptions
    );
  }

  /**
   * Updates collection date of the cod-collection.
   *
   * @param codCollection
   * @returns A promise that resolves with the API response confirming the updating of the collection date.
   */
  updateCollectionDate(codCollection: UpdateCollectionDate): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: codCollection.collectionDate,
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/${codCollection.id}/update-collection-date`,
      requestOptions
    );
  }

  liquidationPreview(liquidation: CreateLiquidation): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(liquidation),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/liquidation/preview`,
      requestOptions
    );
  }

  liquidationSubmit(liquidation: CreateCodLiquidationPreview): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(liquidation),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/liquidation/submit`,
      requestOptions
    );
  }

  liquidationCompanies(codLiquidation: Partial<CodLiquidation>): Promise<any> {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(codLiquidation),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/liquidation/companies`,
      requestOptions
    );
  }

  exportCSV(id: string): Promise<any> {
    const requestOptions = {
      method: "GET",
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/${id}/export`,
      requestOptions,
      { Accept: "*/*" },
      "blob"
    );
  }

  getSuppliers(): Promise<any> {
    const requestOptions = {
      method: "GET",
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/cod-collections/listing/suppliers`,
      requestOptions
    );
  }
}
